import React, { useMemo } from 'react';
import { TBaseTagContext } from '../types';
import UniversalChildren from '../../UniversalTag/UniversalChildren';
import { isArray, isPlainObject, isString } from 'lodash';
import { TTag } from './types';
import { validate } from '@krugom/validator';

export const CustomGroup: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const validationScheme = useMemo(
    () => ({
      type: 'object',
      properties: {
        children: {
          type: 'custom',
          validator: (v: any) => isPlainObject(v) || isArray(v) || isString(v),
        },
      },
    }),
    []
  );

  const result = useMemo(() => validate(tagProps, validationScheme), [tagProps, validationScheme]);

  if (!result.isValid) {
    console.error(
      'Тэг: $Group;',
      `Путь: ${context.path?.join('.') || 'Не указан'};`,
      result.errors
    );
    return <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>;
  }

  return <UniversalChildren context={context}>{tagProps.children}</UniversalChildren>;
});

CustomGroup.displayName = 'CustomGroup';
